import React from 'react'
import { CFView, Text } from 'components'
import { css } from 'emotion'
import { logowhite } from 'images'
import { MEDIA_QUERY } from 'styles'

export default ({
  EmailInputElement,
  CancelButtonElement,
  SubmitButtonElement,
}) => (
  <div className={styles.container}>
    <CFView column w="100%">
      <CFView column w="100%" center mb="4rem">
        <img src={logowhite} alt="Ebisu" width="150" />
      </CFView>
      <CFView mb="2rem">
        <Text heading2 h3 center>
          Please enter your email to send password reset:
        </Text>
      </CFView>
      <CFView mb="2rem">{EmailInputElement}</CFView>
      <CFView row justifyBetween mt="2rem">
        {CancelButtonElement}
        {SubmitButtonElement}
      </CFView>
    </CFView>
  </div>
)

const styles = {
  container: css({
    backgroundColor: '#232323',
    color: 'white',
    padding: '4rem',
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '48rem',
    [MEDIA_QUERY.SM]: {
      padding: '2rem',
      width: '100%',
    },
  }),
}
